export const createSignature = () => {
  var storage_wechatToken = sessionStorage.getItem('wechatToken');
  if (!storage_wechatToken) {
    return false;
  }
  let parameter = JSON.parse(storage_wechatToken)
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: parameter.appid, // 必填，公众号的唯一标识
    timestamp: parameter.timestamp, // 必填，生成签名的时间戳
    nonceStr: parameter.nonceStr, // 必填，生成签名的随机串
    signature: parameter.signature, // 必填，签名
    jsApiList: [
      'checkJsApi',
      'chooseImage',
      'uploadImage',
      'updateTimelineShareData',
      'updateAppMessageShareData',
      'onMenuShareTimeline',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'onMenuShareAppMessage',
      'scanQRCode',
      'getLocation',
      'getNetworkType',
      'hideMenuItems',
      'hideAllNonBaseMenuItem',
      'showMenuItems',
      'showAllNonBaseMenuItem',
      'translateVoice',
      'invokeMiniProgramAPI'
    ] // 判断当前客户端版本是否支持指定JS接口 必填，需要使用的JS接口列表
  });
  wx.error(function (res) {
    console.log(res);
  });
};

export const goToWechatPage = (pageUrl) => {
  const status = pageUrl.indexOf('&access_code');
  const tokenKey = pageUrl.indexOf('&token');
  const tbwxmpTokenKey = pageUrl.indexOf('&tbwxmpToken');
  if (status != -1) {
    pageUrl = pageUrl.replace(/\&access_code/g, '&key');
  }
  if (tokenKey != -1) {
    pageUrl = pageUrl.replace(/\&token/g, '&tokenKey');
  }
  if (tbwxmpTokenKey != -1) {
    pageUrl = pageUrl.replace(/\&tbwxmpToken/g, '&tbwxmpTokenKey');
  }
  const url =
    process.env.cApi + '/kbc-ccs-dc/api/noauth/login/mp/redirect?appCode=ccsDcApp&serviceType=2&tenantId=T0001&clientType=wxmp&url=' + encodeURIComponent(pageUrl)
  return url;
};

// 判断是否微信客户端打开页面
export const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  var isWeixin = ua.indexOf('micromessenger') != -1 && ua.indexOf('mobile') !== -1;
  if (!isWeixin) {
    return false;
  } else {
    return true;
  }
};

// 存入token

export const setUserToken = (data) => {
  sessionStorage.setItem('app_token', data.accessToken);
};


export function parseTime(time, cFormat) {
  console.log(time, cFormat)
  if (arguments.length === 0) {
    return null;
  }
  if (time) {
    if (typeof time == 'string') {
      time = time.replace(/-/g, '/')
    }
  } else {
    return '';
  }
  const format = cFormat || 'y-m-d h:i:s';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/(y|m|d|h|i|s|a)+/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return '星期' + ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}



// WEBPACK FOOTER //
// ./src/utils/index.js